'use strict';

export default {
  methods: {
    makeUrl(url){
      return this.$router.options.base + url;
    }
  }
}